import {
    Checkbox,
    ExpansionPanel,
    ExpansionPanelDetails,
    ExpansionPanelSummary,
    FormControl,
    FormControlLabel,
    FormGroup,
    makeStyles,
    withStyles,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addFilter, removeFilter } from '../actions/setFilters';
import styles from '../css/filter.module.css';
import { getAvailableFilters, getFiltersForCheckBox } from '../selectors';

const useStyles = makeStyles({
    root: {
        background: 'none',
        color: 'var(--white)',
        boxShadow: 'none',
    },
    expansionSummary: {
        textTransform: 'uppercase',
        fontWeight: '700',
        padding: 0,
    },
    expansionDetails: {
        padding: 0,
        '& .MuiTypography-body1': {
            color: 'var(--grey)',
            textTransform: 'capitalize',
            fontWeight: '700',
        },
    },
});

const GoldCheckbox = withStyles({
    root: {
        color: 'var(--gold)',
        '&$checked': {
            color: 'var(--gold)',
        },
    },
    checked: {},
})((props) => <Checkbox {...props} />);

const CheckBoxFilter = (props) => {
    const classes = useStyles();

    const availablefilters = useSelector((state) => getAvailableFilters(state));
    const reduxFilters = useSelector((state) => getFiltersForCheckBox(state));

    const dispatch = useDispatch();
    const handleCheckBox = (filterName, filterValue, checked) => {
        if (checked) {
            dispatch(addFilter(filterName, filterValue));
        } else {
            dispatch(removeFilter(filterName, filterValue));
        }
    };

    return (
        <div className={styles.checkboxes}>
            {Object.keys(availablefilters).map((key) => {
                let sum = Object.keys(availablefilters[key]).reduce(
                    (sum, cur) => sum + availablefilters[key][cur],
                    0
                );
                return sum ? (
                    <ExpansionPanel key={key} className={classes.root}>
                        <ExpansionPanelSummary
                            expandIcon={<ExpandMoreIcon />}
                            className={classes.expansionSummary}
                        >
                            {`${key} `}
                            <span className={styles.num}>{` ${sum}`}</span>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails
                            className={classes.expansionDetails}
                        >
                            <FormControl>
                                <FormGroup>
                                    {Object.keys(availablefilters[key]).map(
                                        (value) => {
                                            return (
                                                <FormControlLabel
                                                    key={value}
                                                    control={
                                                        <GoldCheckbox
                                                            name={value}
                                                            checked={reduxFilters[
                                                                key
                                                            ].includes(value)}
                                                            onChange={(event) =>
                                                                handleCheckBox(
                                                                    key,
                                                                    event.target
                                                                        .name,
                                                                    event.target
                                                                        .checked
                                                                )
                                                            }
                                                        />
                                                    }
                                                    label={`${value} (${availablefilters[key][value]})`}
                                                />
                                            );
                                        }
                                    )}
                                </FormGroup>
                            </FormControl>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                ) : null;
            })}
        </div>
    );
};

export default CheckBoxFilter;
